<template>
  <div class="app-footer d-none-print">
    <div v-if="ovalBackground" class="d-none d-md-block oval-parent bg-blue-450">
      <div :class="`oval ${ovalBackground}`"></div>
    </div>
    <WFooter variant="ap" :linksSection="footerLinks"></WFooter>
    <div class="app-footer__version">{{ version }}</div>
  </div>
</template>

<script setup lang="ts">
import { version } from '@/../package.json'
import { useSwdBreakpoints } from '@/composables'
import links from '@/constants/links'
import { computed } from 'vue'
import { useI18n } from 'vue-i18n'

type Props = {
  ovalBackground?: string
  showLinksOnMobile?: boolean
}

const props = withDefaults(defineProps<Props>(), {
  showLinksOnMobile: true
})

const { t } = useI18n()

// Overwrite the default WiosnaUI footer links
const swdFooterLinks = {
  title: 'Przydatne linki',
  links: [
    { text: t('footer.links.faq'), href: links.academyFaq },
    { text: t('footer.links.homeAp'), href: links.homeAp },
    { text: t('footer.links.homeWiosna'), href: links.websiteSpring },
    { text: t('footer.links.otherFormOfHelp'), href: links.otherFormOfHelp },
    { text: t('footer.links.blogAp'), href: links.blogAp },
    { text: t('footer.links.rules'), href: links.regulations },
    { text: t('footer.links.privacyPolicy'), href: links.privacyPolicy }
  ]
}

const breakpoints = useSwdBreakpoints()
const mdAndGreater = breakpoints.greaterOrEqual('md')

const showFullVersion = computed(() => props.showLinksOnMobile || mdAndGreater.value)

const footerLinks = computed(() => {
  return showFullVersion.value ? swdFooterLinks : null
})

const copyrightDisplay = computed(() => (showFullVersion.value ? 'block' : 'none'))
</script>
<style lang="scss">
.app-footer {
  position: relative;

  a:hover {
    color: inherit;
  }

  &__version {
    position: absolute;
    bottom: 0;
    left: 1rem;
    color: rgb(250 249 246 / 50%);
    font-size: 14px;
  }

  .o-apFooter__copyright,
  .a-wDivider {
    display: v-bind(copyrightDisplay);
  }
}
</style>
